import { MAIN_CONTENT_ID } from '@shared/constants/ContentIdValues';
import { BodyHeaderWrapper, BodyLayout, BodyMainContent, BodyPageContent } from './CommonBodyLayoutStyles';
import SkipToMain from './SkipToMain';

interface IHeaderOnlyLayoutProps {
    children: React.ReactNode;
    headerContent: React.ReactNode;
    offset?: number;
}

export default function HeaderOnlyLayout({ children, headerContent, offset = 0 }: IHeaderOnlyLayoutProps) {
    return (
        <BodyLayout $offset={offset}>
            <SkipToMain scrollToId={MAIN_CONTENT_ID} />
            <BodyHeaderWrapper>{headerContent}</BodyHeaderWrapper>
            <BodyPageContent>
                <BodyMainContent id={MAIN_CONTENT_ID} tabIndex={-1}>
                    {children}
                </BodyMainContent>
            </BodyPageContent>
        </BodyLayout>
    );
}
